
import { h, Fragment, createContext, isValidElement } from 'preact'
import { render } from 'preact-render-to-string'
import { useContext } from 'preact/hooks'
import { isClient, isServer } from '@util/env'


// context to check whether a hydrated component
// is already in a hydrated component

let HydrationContext


// stores all hydration data with id

let _hydrationData = {}
let _id = 0;

if (isServer) {
	HydrationContext = createContext(false)
}


export const getHydrationData = () => JSON.stringify(_hydrationData)


export const withHydration = (Component, givenName) => (props) => {

	if (isClient) return <Component {...props} /> 

	const name = givenName || Component.name || Component.prototype?.constructor?.name
	const componentID = ++_id
	const hasParentHydration = useContext(HydrationContext)

	if (typeof Component !== 'function')
		throw new Error(`Component passed to withHydration is not a function`)

	if (!name) 
		throw new Error(`Component is an anonymous function, and cannot be hydrated`)
	
	if (!hasParentHydration && Object.values(props).find((prop) => typeof prop === 'function'))
		throw new Error(`Can’t save function props in hydration data, component "${name}"`)

	// only add hydration data for the top-most component

	if (!hasParentHydration)
		_hydrationData[componentID] = { name, props }

	return hasParentHydration
		? <Component {...props} /> 
		: <>
			<script type="marker" data-id={componentID} />
			<HydrationContext.Provider value={true}><Component {...props} /></HydrationContext.Provider>
		</>
}


export const HydrationData = () => {
	
	const data = getHydrationData()

	// delete the hydration data for the next page
	// (HydrationData can only be used once per page)
	_hydrationData = {}

	return (
		<script 
			type="hydration-data" 
			dangerouslySetInnerHTML={{  __html: data }}
		/>
	)
}